import type { BannerAdProvider } from "./adPorts.js";

export interface LazyBannerProviderOptions {
  readonly warn?: (message: string) => void;
}

/**
 * Defers a concrete banner provider until an async loader finishes.
 *
 * Calls made before load completion store the latest show/remove intent and
 * replay it once after the provider is available.
 */
export class LazyBannerProvider implements BannerAdProvider {
  private impl: BannerAdProvider | null = null;
  private desired: boolean | null = null;

  constructor(
    loader: () => Promise<BannerAdProvider>,
    private readonly options: LazyBannerProviderOptions = {},
  ) {
    void Promise.resolve()
      .then(loader)
      .then((provider) => {
        this.impl = provider;
        if (this.desired === true) provider.showBanner();
        else if (this.desired === false) provider.removeBanner();
      })
      .catch((e: unknown) => {
        this.options.warn?.(`[banner][V][LazyBannerProvider.load] failed: ${String(e)}`);
      });
  }

  showBanner(): void {
    this.desired = true;
    this.impl?.showBanner();
  }

  removeBanner(): void {
    this.desired = false;
    this.impl?.removeBanner();
  }
}
